import { SeoTrackingEvent } from 'nexchange-service/module/seo'

type TOrderDetails = {
    orderId: string
    pair: {
        pairName: string
        fromCurrencyAmount: number
        toCurrencyAmount: number
    }
    referralToken: string
}

type TUserDetails = {
    email: string
    username: string
    userRefCode: string
}

type TOrderCreationEventProps = {
    userDetails: TUserDetails
    orderDetails: TOrderDetails
}

interface IOrderCreationEvent extends SeoTrackingEvent {
    eventName: string
    orderDetails: TOrderDetails
}

const orderCreationEventName = 'OrderCreation'

class OrderCreation implements IOrderCreationEvent {
    eventName = orderCreationEventName
    userDetails: TUserDetails
    orderDetails: TOrderDetails

    constructor({ userDetails, orderDetails }: TOrderCreationEventProps) {
        this.userDetails = { ...userDetails }
        this.orderDetails = { ...orderDetails }
    }
}

export { OrderCreation }
